import React from "react";

import { formatCurrency } from "../../../../../utils";
import { CompositionLegendProps } from "./types";
import {
  Legend,
  LegendRow,
  LegendLabel,
  Swatch,
  LegendName,
  LegendValue,
  LegendAmount,
  LegendPercent,
} from "./styles";

// The dash lives here, not in `formatCurrency`, so a null amount never prints a confident `0,00 €`.
export const CompositionLegend: React.FC<CompositionLegendProps> = ({
  rows,
}) => (
  <Legend>
    {rows.map((row) => (
      <LegendRow key={row.key} $divided={row.divided}>
        <LegendLabel>
          {row.swatchColor && <Swatch $color={row.swatchColor} />}
          <LegendName>{row.label}</LegendName>
        </LegendLabel>
        <LegendValue>
          <LegendAmount $color={row.amountColor} data-testid={row.testId}>
            {row.amount === null ? "—" : formatCurrency(row.amount)}
          </LegendAmount>
          {row.percent !== undefined && (
            <LegendPercent>{row.percent}%</LegendPercent>
          )}
        </LegendValue>
      </LegendRow>
    ))}
  </Legend>
);
